import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../enums/user-role.enum';
import { ToastService } from '../../shared/components/toast-notification/toast.service';
import { map } from 'rxjs';

export function defaultRouteForRole(role: UserRole | null): string {
    switch (role) {
        case UserRole.ACCOUNTING:
            return '/finance/treasury';
        case UserRole.CENTRAL:
            return '/customer-service/radar';
        case UserRole.ADMIN:
        case UserRole.AGENT:
        case UserRole.EMISSIONS:
        case UserRole.ANALYST:
        default:
            return '/dashboard';
    }
}

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const toastService = inject(ToastService);

    const allowedRoles = route.data['roles'] as UserRole[] | undefined;

    return authService.ensureSession().pipe(
        map((isAuthenticated) => {
            if (!isAuthenticated) {
                return router.createUrlTree(['/auth/login'], {
                    queryParams: { returnUrl: state.url },
                });
            }

            if (!allowedRoles || allowedRoles.length === 0) return true;

            const userRole = authService.currentUserRole();
            if (userRole && allowedRoles.includes(userRole)) return true;

            toastService.warning('Acceso denegado: No tienes permisos para acceder a esta sección.');
            return router.createUrlTree([defaultRouteForRole(userRole)]);
        })
    );
};
